'use client';

import React from 'react';
import Image from 'next/image';

interface AppLogoProps {
  src?: string;
  text?: string;
  iconName?: string;
  size?: number;
  className?: string;
  onClick?: () => void;
  width?: number;
  height?: number;
}

function AppLogo({
  src = '/assets/images/logo-turquesa.png',
  text,
  iconName = 'SparklesIcon',
  size = 64,
  width,
  height,
  className = '',
  onClick,
}: AppLogoProps) {
  const imgWidth = width ?? Math.round(size * 2.7);
  const imgHeight = height ?? size;

  return (
    <div
      className={`flex items-center gap-2 ${onClick ? 'cursor-pointer hover:opacity-80' : ''} ${className}`}
      onClick={onClick}
    >
      {src ? (
        <Image
          src={src}
          alt="IMPACTA.red logo"
          width={imgWidth}
          height={imgHeight}
          className="flex-shrink-0 object-contain"
          priority
        />
      ) : (
        <span className="text-xl font-bold">{text}</span>
      )}
    </div>
  );
}

export default AppLogo;
